import { Box } from '@mui/material'
import { EthAddress } from '@xylabs/sdk-js'
import { useContext } from 'react'
import { Helmet } from 'react-helmet'
import { useParams } from 'react-router-dom'

import { EntitySettingsLoader, EthersContext } from '../../Contexts'
import { EntityTypeProperty, LocalAddressProperty } from '../../Properties'
import { EntityToolbar } from '../../Toolbar'
import WorldBasePage from '../WorldBasePage'

const SettingsPage: React.FC = () => {
  const { localAddress } = useContext(EthersContext)
  const { id } = useParams()
  const addressRequested = EthAddress.fromString(id) ?? localAddress

  if (addressRequested) {
    return (
      <WorldBasePage>
        <Helmet title="Application Settings" />
        <EntitySettingsLoader address={addressRequested}>
          <EntityToolbar />
          <Box display="flex" flexDirection="column" justifyContent="center">
            <LocalAddressProperty />
            <EntityTypeProperty />
          </Box>
        </EntitySettingsLoader>
      </WorldBasePage>
    )
  } else {
    return null
  }
}

export default SettingsPage
